<template>
    <div @click="calcelPersonBox" v-if="personBoxBool" class="person-box">
        <div style="padding:0 20px;position:relative">
            <a-input v-model="searchName" @change='nameChange' placeholder="搜索姓名" style="padding-left:32px;border:1px solid rgba(158, 172, 196, 0.3)" />
            <a-icon style="position:absolute;left:30px;top:9px;color:rgba(158, 172, 196, 0.7)" type="search" />
        </div>
        <div class="person-box-tab">
            <span @click="selectUserProvider('user')" :class="{'active':currentUserProvider=='user'}">用户</span>
            <span @click="selectUserProvider('provider')" :class="{'active':currentUserProvider=='provider'}">服务商</span>
        </div>
        <div class="user-provider-box">
            <div v-if="currentUserProvider=='user'" class="user-box">
                <ul>
                    <li @click="selectUser(item.value)" :class="{'active':selectedUser==item.value}" class="name-box" v-for="(item,index) in userTree.userList" :key='index'>
                        <span v-if="item.avatar==''" class="name-abbreviation">{{item.title.slice(0,1)}}</span>
                        <img v-if="item.avatar!=''" style="object-fit: cover" class="name-img" :src="item.avatar" alt="">
                        <span class="name-title">{{item.title}}</span>
                        <a-icon v-if="userObjBool[item.value]" type="check" />
                    </li>
                </ul>
            </div>
            <div v-if="currentUserProvider=='provider'" class="provider-box">
                <a-tree :tree-data="userTree.serviceProviderUserList" default-expand-all @select="onSelect" :default-selected-keys="defaultSelectedKeys"></a-tree>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            personBoxBool: false,
            currentUserProvider: 'user',
            userObjBool: {},
            userTree: '',
            searchName: '',
            selectedUser: '',
            defaultSelectedKeys: []
        }
    },
    methods: {
        calcelPersonBox() {
            event.stopPropagation();
        },
        selectUserProvider(data) {
            this.currentUserProvider = data
        },
        selectUser(id) { 
            this.defaultSelectedKeys = []
            for(let item in this.userObjBool){
                if(id == item){
                    this.userObjBool[id] = true
                    this.selectedUser = id
                }else{
                    this.userObjBool[item] = false
                }
            }
            // this.$parent.selectUserId(this.selectedUser)
            this.$emit('getUserId');
            // this.selectedPersonalBool = true
            this.personBoxBool = false
            this.$forceUpdate();
        },
        queryUserTree() {
            this.axios(
                {
                    method:'get',
                    url:'/api/serviceProviderUser/userQueryCondition', 
                    params: {
                        name: this.searchName
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.userTree = response.data.data
                    let userList = response.data.data.userList
                    for(let i = 0; i < userList.length; i++){
                        this.userObjBool[userList[i]['value']] = false
                    }
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        nameChange() {
            this.queryUserTree()
        },
        onSelect(selectedKeys) {
            this.personBoxBool = false
            this.defaultSelectedKeys = selectedKeys
            this.selectedUser = ''
            for(let item in this.userObjBool){
                this.userObjBool[item] = false
            }
            this.$emit('getProviderId');
        },
    },
    mounted: function() {
        this.queryUserTree()
    }
}
</script>
<style scoped lang="less">
    .person-box{
        width: 280px;
        height: 456px;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
        position: absolute;
        bottom: -470px;
        left: -90px;
        background: #fff;
        z-index: 1000;
        padding: 16px 0;
        display: flex;
        flex-direction: column;
        .person-box-tab{
            height: 38px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            line-height: 26px;
            padding-left: 14px;
            span{
                display: inline-block;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                margin-right: 40px;
                cursor: pointer;
                margin-top:10px;
            }
            span.active{
                border-bottom: 3px solid rgba(58, 220, 255, 1);
                color: rgba(58, 220, 255, 1);
            }
        }
        .user-provider-box{
            flex: 1;
            padding: 8px 0;
            overflow-y: auto;
            .user-box{
                ul{
                    li{
                        height: 44px;
                        padding: 10px 20px 0;
                        cursor: pointer;
                        span.name-abbreviation{
                            display: inline-block;
                            width: 24px;
                            height: 24px;
                            color: #fff;
                            line-height: 24px;
                            text-align: center;
                            font-size: 12px;
                            margin-right: 8px;
                            border-radius: 12px;
                            background: rgba(58, 220, 255, 1);
                        }
                        span.name-title{
                            color: rgba(18, 18, 18, 1);
                            font-size: 13px;
                        }
                        img.name-img{
                            width: 24px;
                            border-radius: 12px;
                            margin-right: 8px;
                        }
                        i{
                            float: right;
                            color: rgba(58, 220, 255, 1);
                            font-size: 16px;
                            margin-top: 6px;
                            
                        }
                    }
                    li:hover{
                        background: rgba(240, 242, 243, 0.5);
                    }
                }
            }
        }
    }
</style>